import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import withMessages from 'component-utilities/intl';
import styles from './Modals.scss';

import ModalContainer from './ModalContainer';
import ModalHeader from './ModalHeader';
import ModalContentLeft from './ModalContentLeft';
import ModalButtons from './ModalButtons';

const BASE_KEY = 'components.modals.session_expiration_warning';

function component({ getMessage, onStillWorking, onLogMeOut, onClose }) {
    return (<ModalContainer>
        <ModalHeader onCloseClick={onClose}>
            {getMessage(`${BASE_KEY}.title`)}
        </ModalHeader>
        <ModalContentLeft>
            <span className={styles['modal-text-bold']}>
                {getMessage(`${BASE_KEY}.main_text`)}
            </span>
            <br />
            <br />
            {getMessage(`${BASE_KEY}.secondary_text`)}
        </ModalContentLeft>
        <ModalButtons
            onPrimaryClick={onStillWorking}
            primaryText={getMessage(`${BASE_KEY}.buttons.primary`)}
            onSecondaryClick={onLogMeOut}
            secondaryText={getMessage(`${BASE_KEY}.buttons.secondary`)}
        />
    </ModalContainer>)
}

component.propTypes = {
    getMessage: PropTypes.func.isRequired,
    onStillWorking: PropTypes.func.isRequired,
    onLogMeOut: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

const SessionExpirationWarningModal = withMessages(component);
SessionExpirationWarningModal.displayName = displayName('Modals/SessionExpirationWarningModal');

export default SessionExpirationWarningModal;
